/** @internal */
export async function start() {
  require("electron-webpack/dev-runner")
}